import { ScoreData, ScorePOI } from "./Score";

export const defaultScoreData: ScoreData = {
  progression: 0,
  chapters: [
    {
      id: "main",
      progression: 0,
      poisCount: 1,
      poisDone: [],
      blockBy: [],
      isLocked: false,
      isDone: false,
    },
    {
      id: "labo",
      progression: 0,
      poisCount: 5,
      poisDone: [],
      blockBy: [],
      isLocked: false,
      isDone: false,
    },
    {
      id: "engin",
      progression: 0,
      poisCount: 5,
      poisDone: [],
      blockBy: ["labo"],
      isLocked: true,
      isDone: false,
    },
    {
      id: "exchange",
      progression: 0,
      poisCount: 5,
      poisDone: [],
      blockBy: ["labo", "engin"],
      isLocked: true,
      isDone: false,
    },
  ],
  // pois: defaultScorePOIData
};

/**
 * not use yet
 * use for make a linear progression of pois
 */
const defaultScorePOIData: ScorePOI[] = [
  {
    id: "engin.p02",
    blockBy: ["engin.p01"],
    isLocked: true,
  },
];
